import "./Workspace.css"

import React, { useEffect, useState } from "react"
import { Outlet } from "react-router-dom"

import FlatteningHeader from "../../components/FlatteningHeader"

type OwnProps = {
  headerStartFlat?: boolean
  pages?: Array<{
    route: string
    label: string
  }>
}

const Workspace = (props: OwnProps): React.ReactElement => {
  const [isHeaderFlat, setIsHeaderFlat] = useState(props.headerStartFlat)

  useEffect(() => {
    if (!isHeaderFlat) {
      setTimeout(() => {
        setIsHeaderFlat(true)
      }, 2000)
    }
  }, [isHeaderFlat])

  return (
    <>
      <FlatteningHeader flattened={isHeaderFlat} />
      <div id="workspace-body" className="workspace-body">
        <Outlet />
        <div className="notice-about-devolution">
          <p>
            Prezado (a),
          </p>
          <p>
            Para o processo de devolução, por favor, utilizar o checklist digital da AutoVist.
          </p>
          <p>
            Caso tenha alguma dúvida ou necessidade de suporte, entre em contato com a área de Logística Reversa no e-mail: <a href="mailto:devolucao@kintomobility.com.br">devolucao@kintomobility.com.br</a>
          </p>
        </div>
      </div>
    </>
  )
}

export default Workspace
